// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    background-color: #379683;
    text-align: center;
    padding: 5px;
    margin-bottom: 10px;
    padding-left: 50px;
}

.header-option {
    padding: 5px;
    color: #EDF5E1;
}

.header-option:hover {
    background-color: #5CDB95;
}

a:link, a:visited{
    text-decoration: none;
    color: #EDF5E1;
}
`, "",{"version":3,"sources":["webpack://./src/css/header.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[".header {\n    background-color: #379683;\n    text-align: center;\n    padding: 5px;\n    margin-bottom: 10px;\n    padding-left: 50px;\n}\n\n.header-option {\n    padding: 5px;\n    color: #EDF5E1;\n}\n\n.header-option:hover {\n    background-color: #5CDB95;\n}\n\na:link, a:visited{\n    text-decoration: none;\n    color: #EDF5E1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
